import * as React from "react";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {AppState} from "../store/app_state";
import {Pager} from "../../domain/model/common";

import {createClientClientBrowsingHistoriesDispatcher, IClientClientBrowsingHistoriesDispatcher} from "../dispatcher/client_client_browsing_histories_dispatcher";
import {createClientClientBrowsingHistoriesActionCreator} from "../action/client_client_browsing_histories_action";
import {GetAllClientBrowsingHistoryByClientRequest} from "../request/client_browsing_history_request";
import {ClientClientBrowsingHistoriesState} from "../store/client_client_browsing_histories_state";
import ClientClientBrowsingHistoriesComponent from "../component/client/client_browsing_histories/client_browsing_histories";
import {TPagination} from "../type/common";
import {frontEndConfig} from "../../config/config";
import {RouteComponentProps} from "react-router-dom";

const defaultOffset = frontEndConfig.defaultOffset;
const pageRangeDisplayed: number = frontEndConfig.defaultPageRangeDisplayed;

interface IProps extends RouteComponentProps<{}> {
    state: ClientClientBrowsingHistoriesState
    dispatcher: IClientClientBrowsingHistoriesDispatcher;
}

interface IState {
    isInit: boolean;
}

export class ClientClientBrowsingHistories extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isInit: true,
        };

    };
    
    public componentDidMount() {
        // 直接アクセスの際のデータ取得
        const params: {activePage: number} = this.helperForSearchPrams(this.props.location.search);
        this.pushQueryString(params.activePage);
    }

    public componentWillReceiveProps(nextProps: Readonly<IProps>, nextContext: any): void {
        // URL遷移の際のデータ取得
        if (nextProps.location !== this.props.location) {
            const params: {activePage: number} = this.helperForSearchPrams(nextProps.location.search);
            const pager: Pager = new Pager(params.activePage, defaultOffset);
            const req: GetAllClientBrowsingHistoryByClientRequest = new GetAllClientBrowsingHistoryByClientRequest();
            req.pager = pager;
            this.props.dispatcher.getAllClientBrowsingHistories(req);
        }
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean = this.state.isInit && !this.props.state.isLoading && prevProps.state.isLoading;
        if (isInitFinished) { return this.setState({isInit: false}) }
    }

    public render (): JSX.Element {

        const {state} = this.props;
        const {isInit} = this.state;

        const {clientBrowsingHistories, customers, jobCareersWithCustomerID, clientBookmarks, isLoading} = state;

        const totalItemsCount: number = this.props.state.customerCount;
        const itemsCountPerPage: number = defaultOffset;

        const params: {activePage: number} = this.helperForSearchPrams(location.search);

        const paginationPrams: TPagination = {
            activePage: params.activePage,
            itemsCountPerPage,
            totalItemsCount,
            pageRangeDisplayed,
            onChange: this.handlePageChange,
        };

        let res: JSX.Element;

        res = <ClientClientBrowsingHistoriesComponent
            isInit={isInit}
            clientBrowsingHistories={clientBrowsingHistories}
            customers={customers}
            jobCareersWithCustomerID={jobCareersWithCustomerID}
            clientBookmarks={clientBookmarks}
            isLoading={isLoading}
            paginationPrams={paginationPrams}
        />;

        return (res)
    }

    private helperForSearchPrams = (urlSearchParams: any): {activePage: number} => {
        const params = new URLSearchParams(urlSearchParams);
        let activePage: number = params.get('p') ? Number(params.get('p')) : 1;
        if (Number.isNaN(activePage)) { activePage = 1 }

        const res: {activePage: number} = {
            activePage,};
        return res;
    }

    private pushQueryString = (activePage: number): void => {
        const {location, history} = this.props;
        const params = new URLSearchParams(location.search);
        params.set('p', activePage.toString());
        history.push({
            search: params.toString(),
        });
    }

    private handlePageChange = (pageNumber: number): void => {
        this.pushQueryString(pageNumber)
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.clientClientBrowsingHistoriesReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createClientClientBrowsingHistoriesDispatcher(dispatch, createClientClientBrowsingHistoriesActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientClientBrowsingHistories);



// WEBPACK FOOTER //
// ./src/presentation/container/client_client_browsing_histories_container.tsx